import { render, staticRenderFns } from "./MessageDialog.vue?vue&type=template&id=a225a9c6&scoped=true"
import script from "./MessageDialog.vue?vue&type=script&lang=ts"
export * from "./MessageDialog.vue?vue&type=script&lang=ts"
import style0 from "./MessageDialog.vue?vue&type=style&index=0&id=a225a9c6&prod&lang=scss&scoped=true"
import style1 from "./MessageDialog.vue?vue&type=style&index=1&id=a225a9c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a225a9c6",
  null
  
)

export default component.exports